import { Button, Dialog, DialogActions, DialogContent, Stack, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { closeUpgradePopUp } from "@/store/uiSlice";
import useRoutes from "@/hooks/useRoutes";

const UpgradeModal = () => {
  const dispatch = useAppDispatch();
  const isUpgradePopUpOpen = useAppSelector((store) => store.ui.isUpgradePopUpOpen);
  const upgradeMessage = useAppSelector((store) => store.ui.upgradeMessage);
  const [navigate] = useRoutes();

  return (
    <Dialog
      maxWidth="xs"
      open={isUpgradePopUpOpen}
      onClose={() => {
        dispatch(closeUpgradePopUp());
      }}
    >
      <DialogContent>
        <Stack spacing={2}>
          <Typography textAlign="center" variant="h2" color="primary">
            {upgradeMessage}
          </Typography>
          <Typography textAlign="center">Actualiza tu plan para desbloquear esta y mas funciones premium</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="success"
          fullWidth
          onClick={() => {
            navigate("organizations.pricing.main");
            dispatch(closeUpgradePopUp());
          }}
        >
          Actualizar Plan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeModal;
